import React, { Fragment } from 'react'
import { useMemo } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import Link from '../Link/Link'


const getBrandLink = ({ gender, name }) => {
  const brand = name.replace(/\s/g, '-').toLowerCase()
  const tail  = gender === 'female' ? '-perfumes' : '-colognes'

  return `/${brand}${tail}`
}

const BrandLinks: React.FunctionComponent = () => {
  const { gender, brands } = useConnect({
    gender: 'view.seoPage.gender',
    brands: 'view.seoPage.brands',
  })

  const links = useMemo(() => (
    brands
      .filter(({ name }) => Boolean(name))
      .map(({ name, count, value }, index) => {
        const link = getBrandLink({ name, gender })

        return (
          <Box key={index} mt={index ? 8 : null}>
            <Link to={link}>
              <Text
                message={`${name} (${count})`}
                size="12-24"
                color="black"
              />
            </Link>
          </Box>
        )
      })
  ), [ brands ])

  return (
    <Fragment>
      {links}
    </Fragment>
  )
}


export default BrandLinks
